<script setup lang="ts">
import type { PdpEcommerceBlockFitFinderProps } from '@design-system/components/Pdp/EcommerceBlock/PdpEcommerceBlockFitFinder.props'
import type {
  Category,
  SizeDetails,
} from '@design-system/components/Pdp/PdpFitFinder.props'
import { SIDEBAR_IDS } from '@design-system/data/sidebarIds'

const props = defineProps<PdpEcommerceBlockFitFinderProps>()
const emit = defineEmits<{
  onFitFinderClick: []
}>()

const { openDialog, closeDialog } = useDialog(
  SIDEBAR_IDS.pdpEcommerceBlockFitFinder
)

const { emitSizebayProductViewEvent } = useSizebayEvents()
const route = useRoute()

const noSizeBay = computed(() => {
  if (process.server) return false
  return route.query.noSizeBay === 'true'
})

const testId = computed(() => (!noSizeBay.value ? 'fit-finder' : ''))

onBeforeMount(async () => {
  if (!props.hideSidebar && !noSizeBay.value) {
    await useSizebay()
    emitSizebayProductViewEvent(props.productId, props.productTitle)
  }
})

const {
  sizeGridData: sizeData,
  productCategory,
  countries,
} = await useFitFinder(props.sizeCodeId ?? '', props.mainCategory)

const handlePrimaryClick = () => {
  closeDialog()
}
const handleFitFinderClick = () => {
  setTimeout(() => {
    const sizeBayModalOk = document
      .querySelector('html')
      ?.classList.contains('vfr-modal-active')
    if (!sizeBayModalOk) {
      openDialog()
    }
  }, 300)
  emit('onFitFinderClick')
}
</script>

<template>
  <AsideButton
    class="border-t-0"
    :data-testid="testId"
    :aria-label="$ts('accessibility.openFitFinder')"
    @click="handleFitFinderClick"
  >
    <p class="text-medium-6">
      {{ customLabel ?? $ts('pdp.fitFinder.label') }}
    </p>
  </AsideButton>

  <OrganismsSidebarSlide
    v-if="!hideSidebar"
    :id="SIDEBAR_IDS.pdpEcommerceBlockFitFinder"
    :header-props="{
      titleText: $ts('pdp.fitFinder.label'),
    }"
    @primary-click="handlePrimaryClick"
  >
    <template #body>
      <PdpFitFinder
        :category="productCategory as unknown as Category"
        :countries="countries"
        :sizes-details="sizeData as unknown as SizeDetails[]"
        :side-slide-description="props.sideSlideDescription"
        :size-code-id="sizeCodeId"
      />
    </template>
  </OrganismsSidebarSlide>
</template>
